import styles from "@/styles/article/award-winning.module.scss";
import Image from "next/image";

import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();
const imageDomain = publicRuntimeConfig.imageDomain;

export default function CompAwardWinningContent() {
  const awardList = [
    {
      title: "Hitwise Top 10 Website, June-December 2010",
      desc: `We're not stopping! We couldn't let six months pass without winning another award and yes, We're still in the Hitwise Top 10! Another award for CrazySales.`,
      imageUrl: `${imageDomain}/legal/top-10-website-2010-2.png`,
    },
    {
      title: `Hitwise Top 10 Website, January-June 2010`,
      desc: `CrazySales wins again in 2010! Another 8th place award in the Australian online shopping category from Hitwise, the world's leading competitive intelligence service.`,
      imageUrl: `${imageDomain}/legal/top-10-website-2010.png`,
    },
    {
      title: `Hitwise Top 10 Website, October-December 2009`,
      desc: `As thrilled as we were with our first two Hitwise awards, they simply weren't enough. We shot up two rankings to 8th place in the second half of 2009!`,
      imageUrl: `${imageDomain}/legal/top-10-website-2009-2.png`,
    },
    {
      title: `Hitwise Top 10 Website, January-June 2009`,
      desc: `After our last achievement, we immediately followed it with another 10th place award for Australian online shopping websites from Hitwise for the first half of 2009`,
      imageUrl: `${imageDomain}/legal/top-10-website-2009.png`,
    },
    {
      title: `Hitwise Top 10 Website, October-December 2008`,
      desc: `Between October and December CrazySales was ranked 10th for online shopping in Australia by Hitwise.`,
      imageUrl: `${imageDomain}/legal/top-10-website-2008.png`,
    },
  ];

  return (
    <div className={styles["comp-award-winning"]}>
      <Image
        className={styles["banner-img"]}
        style={{ display: "block", margin: "0 auto" }}
        src={`${imageDomain}/legal/award-winning-banner.png`}
        alt={"crazy-points-banner"}
        width={800}
        height={139}
      ></Image>
      <div className={`${styles["ask-title"]} padding-top-16`}>
        Award-Winning Online Shopping in Australia
      </div>

      <div className={`${styles["answer-desc"]} padding-top-16`}>
        We won&apos;t be happy until CrazySales.com.au is the most popular
        destination for online shopping in Australia, and we&apos;re steadily on our
        way to achieving our goal. We&apos;re not going to rest until our collection
        of awards is as unbeatable as our prices and service.
      </div>

      <div className={`${styles["award-list"]} padding-top-16`}>
        {awardList.map((item: any, index: number) => (
          <div className={styles["award-item"]} key={index}>
            <Image
              className={styles["award-img"]}
              src={item.imageUrl}
              alt={item.title}
              width={105}
              height={116}
            ></Image>

            <div className={styles["award-info"]}>
              <div className={styles["award-title"]}>{item.title}</div>
              <div className={styles["award-desc"]}>{item.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
